module.exports = {
  isHeadwayTail: 'หัวลาก หางลาก',
  containerLoadType: 'ประเภทการมอบหมาย',
  transportType: 'ประเภทการขนส่ง',
  fullHalf: 'ทั้งหมด / ครึ่งทาง',
  transportLine: 'เส้นทางบิน',
  ETD: 'วันที่จัดส่ง',
  ETA: 'วันที่มาถึง',
  ATD: 'วันที่จัดส่งจริง',
  ETD2: 'วันที่จัดส่ง (ETD)',
  ETA2: 'วันที่มาถึง (ETA)',
  ATD2: 'วันที่จัดส่งจริง (ATD)',
  ATA2: 'วันที่มาถึงจริง (ATA)',
  departureStation: 'สถานีต้นทาง',
  departureStationRe: 'สถานีต้นทาง (รถไฟ)',
  transferStation: 'สถานีขนส่ง',
  transitStation: 'สถานีขนส่ง',
  destinationStation: 'สถานีปลายทาง',
  destinationStationRe: 'สถานีปลายทาง (รถไฟ)',
  destinationCountry: 'ประเทศปลายทาง',
  portAgent: 'ตัวแทนท่าเรือ',
  forwardingAgent: 'ตัวแทนจัดส่งสินค้า',
  paymentMethod: 'วิธีการชำระเงิน',
  mbl: 'หมายเลขใบนำส่งสินค้า',
  vessel: 'รถรับส่ง',
  voyageFlight: 'จำนวนรถ',
  isDiffPlacesCollaborate: 'การทำงานร่วมกันนอกสถานที่',
  loadingPlaceCompany: 'บริษัท สถานที่โหลด',
  signBillPlaceCompany: 'บริษัท Signature Land',
  isFullShipment: 'การจัดส่งสินค้าทั้งหมด',
  dischargePortCompany: 'บริษัท ท่าเรือขนถ่าย',
  destinationPortCompany: 'ท่าเรือปลายทาง บริษัท',
  overseaOp: 'ฝ่ายบริการลูกค้าต่างประเทศ',
  planner: 'หัวหน้าเส้นทาง',
  plannerOffice: 'บริษัท เส้นทาง',
  plannerDepartment: 'แผนกเส้นทาง',
  batchVessel: 'การโอนแบทช์',
  Query: 'สอบถาม',
  BuyContainer: 'ซื้อกล่อง',
  CallContainer: 'ย้ายตู้',
  SellContainer: 'กล่องขาย',
  RentContainer: 'กล่องเช่า',
  ClearContainerLog: 'ลบประวัติการย้ายตู้',
  ReturnBox: 'คืนตู้',
  Edit: 'บรรณาธิการ',
  Delete: 'ลบ',
  OrderNo: 'หมายเลขการสั่งซื้อ',
  OrderNo2: 'รหัสใบสั่ง',
  JobNo2: 'รหัสธุรกิจ',
  ConsignationCompany: 'ลูกค้ามอบหมาย',
  BoxOwner: 'เจ้าของตู้/ผู้ขาย',
  BoxOwner3: 'เจ้าของตู้',
  BoxOwner2: 'ผู้ขาย',
  Buyer2: 'ผู้ซื้อ',
  Buyer: 'ผู้ซื้อ',
  OrderType: 'ประเภทการสั่งซื้อ',
  ContainerStatus: 'สถานะกล่อง',
  ContainerType: 'ประเภทตู้คอนเทนเนอร์',
  Amount: 'จำนวนเงิน',
  WhetherSettlement: 'ไม่ว่าจะเป็นการตั้งถิ่นฐาน',
  SettlingTime: 'วันที่ชำระราคา',
  BuyerTime: 'วันที่ซื้อกล่อง',
  SellTime: 'วันที่ขายกล่อง',
  ReturnTime: 'วันที่คืนเงิน',
  OperationTime: 'วันที่ดำเนินการ',
  Prompt1: 'กรุณากรอกหมายเลขคำสั่งซื้อ',
  Prompt2: 'กรุณากรอกหมายเลขตู้',
  QuantitySum: 'จำนวนตู้ทั้งหมด',
  AmountSum: 'ยอดเงินรวม',
  Quantity2: 'จำนวน',
  BuyTime: 'วันที่ซื้อ',
  SellerDate: 'วันที่ขาย',
  RentDate: 'วันที่เริ่มเช่า',
  StartRentDate: 'วันที่เริ่มเช่า',
  ReturnDate: 'วันที่สิ้นสุด',
  UnitRate: 'ราคาต่อหน่วย',
  ContainerNo: 'หมายเลขตู้',
  CurrencyCode: 'สกุลเงิน',
  EQSize: 'รูปแบบตู้',
  EQType: 'ชนิดตู้',
  EQQuantity: 'จำนวนตู้',
  Add: 'เพิ่ม',
  Confirm: 'ยืนยัน',
  Cancel: 'ยกเลิก',
  Operation: 'ดำเนินการ',
  UnitRate2: 'ราคาต่อหน่วย (หยวน/วัน)',
  UnitRate3: 'หยวน/วัน',
  ReturnBoxDate: 'เวลาคืนตู้',
  Term: 'ระยะเวลา',
  Day: 'วัน',
  UnitPriceInterval: 'ช่วงราคาต่อหน่วย',
  BuyBoxTotalTankVolume: 'จำนวนตู้ที่ซื้อทั้งหมด',
  TotalCost: 'ยอดเงินต้นทุนรวม',
  SellOutTotalTankVolume: 'จำนวนตู้ที่ขายทั้งหมด',
  TotalSalesAmount: 'ยอดเงินขายรวม',
  CostUnitPrice: 'ราคาต้นทุนต่อหน่วย',
  CostUnitPriceCurrencyCode: 'สกุลเงินราคาต้นทุนต่อหน่วย',
  SellingUnitPrice: 'ราคาขายต่อหน่วย',
  SellingUnitPriceCurrencyCode: 'สกุลเงินราคาขายต่อหน่วย',
  ETDNotNull: 'วันที่ส่งสินค้าไม่สามารถเว้นว่างได้',
  ETANotNull: 'วันที่ถึงไม่สามารถเว้นว่างได้',
  PaymentMethodCannotBlank: 'วิธีการชำระเงินไม่สามารถเว้นว่างได้',
  DepartureStationCannotEmpty: 'สถานีต้นทางไม่สามารถเว้นว่างได้',
  TransferStationCannotEmpty: 'สถานีกลางไม่สามารถเว้นว่างได้',
  TransitStationCannotEmpty: 'สถานีผ่านแดนไม่สามารถเว้นว่างได้',
  DestinationStationCannotEmpty: 'สถานีปลายทางไม่สามารถเว้นว่างได้',
  CharacterLengthTooLongMaintainAgain: 'ความยาวตัวอักษรเกินกำหนด กรุณาตรวจสอบใหม่!',
  TheNotOnTheBustrain: 'เอกสารที่เลือกไม่ใช่รถเที่ยวเดียวกัน',
  OperationFailed: 'การดำเนินการล้มเหลว',
  SelectTime: 'เลือกเวลา',
  BulkModifyDestinationPortInformation: 'แก้ไขข้อมูลท่าเรือปลายทางแบบกลุ่ม',
  NonWarehouseOverseasTransferWarehouse: 'คลังสินค้าต่างประเทศไม่ใช่คลัง Amazon',
  EstimatedDeliveryTime: 'เวลาจัดส่งตามประมาณการ',
  ActualDeliveryTime: 'เวลาจัดส่งจริง',
  DomesticWarehouse: 'คลังในประเทศ',
  OverseasWarehouse: 'คลังต่างประเทศ',
  WithCostRefundForClearing: '(มีค่าธรรมเนียมการยกเลิกศุลกากร)',
  TheExpiresAndNoCreated: 'สัญญาของหน่วยงานที่มอบหมายสิ้นสุดแล้ว ไม่สามารถสร้างธุรกิจใหม่ได้',
  DueNotBePrintedNeeded: 'เนื่องจากเกินวงเงินเครดิต บิลนี้ถูกล็อคแล้ว จะไม่สามารถพิมพ์หรือใช้ EDI ได้ กรุณาติดต่อผู้ดูแลเพื่อปลดล็อกเมื่อจำเป็น!',
  LockedPleaseContactTheUnlock: 'ถูกล็อคแล้ว ไม่สามารถพิมพ์ได้ กรุณาติดต่อผู้ดูแลปลดล็อก!',
  FCLProfitPrint: 'พิมพ์กำไรแบบเต็มตู้',
  AttachmentContentTooLarge: 'เนื้อหาภาพแนบมีขนาดใหญ่เกินไป',
  LCLProfitPrint: 'พิมพ์กำไรแบบรวมตู้',
  ContainerType2: 'ประเภทตู้',
  AdjustmentOperation: 'การจัดการตู้คอนเทนเนอร์',
  All: 'ทั้งหมด',
  Days: 'วัน',
  ExpectedToEnterAmazonWarehouse: 'เวลาที่คาดว่าจะเข้าคลัง Amazon',
  ReferenceContainerNumber: 'หมายเลขตู้อ้างอิง',
  Export: 'ส่งออก',
  Import: 'นำเข้า',
  ReturnContainer: 'คืนตู้',
  PleaseEnterContainerInformation: 'กรุณากรอกข้อมูลตู้คอนเทนเนอร์!',
  PleaseEnterReturnContainerTime: 'กรุณากรอกเวลาคืนตู้!',
  ReturnSuccessfulSuccessfulReturnCount: 'การคืนตู้สำเร็จ! จำนวนตู้ที่คืนสำเร็จ:',
  NumberOfContainerPieces: 'จำนวนชิ้นต่อตู้:',
  GreaterActualNumberOfPieces: 'มากกว่าจำนวนชิ้นจริง:',
  ContainerWeight: 'น้ำหนักต่อตู้:',
  GreaterThanTheActualWeight: 'มากกว่าน้ำหนักจริง:',
  ContainerVolume: 'ปริมาตรต่อตู้:',
  GreaterThanTheActualVolume: 'มากกว่าปริมาตรจริง:',
  JobNumber: 'หมายเลขงาน:',
  ServiceChannel: 'ช่องทางบริการ',
  PostalCode: 'รหัสไปรษณีย์',
  DestinationDeliveryMethod: 'วิธีการจัดส่งปลายทาง',
  ExpressCompany: 'บริษัทขนส่ง',
  TrackingNumber: 'หมายเลขพัสดุ',
  POoriginalOrderNumber: 'PO (หมายเลขเดิม)',
  CustomsDeclarationMethod: 'วิธีการสำแดงศุลกากร',
  CustomsClearanceMethod: 'วิธีการผ่านศุลกากร',
  EORIEnterpriseNumber: 'หมายเลข EORI ของบริษัท',
  VATtaxNumber: 'VAT/หมายเลขภาษี',
  VATRegistrationCountry: 'ประเทศที่จด VAT',
  VATRegistrationAddress: 'ที่อยู่ลงทะเบียน VAT',
  VATCompanyEnglishName: 'ชื่อบริษัทภาษาอังกฤษสำหรับ VAT',
  WithBattery: 'มีแบตเตอรี่',
  WithMagnet: 'มีแม่เหล็ก',
  Powder: 'ผง',
  Liquid: 'ของเหลว',
  EstimatedStoragegoodsReadyTime: 'เวลาที่คาดว่าจะเข้าคลัง/สินค้าพร้อม',
  RemoteWarehouse: 'คลังสินค้าห่างไกล',
  ThisHasExpiredCannotBusiness: 'สัญญาของหน่วยงานที่มอบหมายสิ้นสุดแล้ว ไม่สามารถสร้างธุรกิจใหม่ได้',
  Freight: 'ค่าขนส่ง',
  ServiceChannel2: 'ช่องทางบริการ:',
  CostType: 'ประเภทค่าใช้จ่าย:',
  EstimatedAmount: 'จำนวนเงินโดยประมาณ:',
  EquivalentTo: 'เท่ากับ',
  FareLevel: 'ระดับอัตราค่าขนส่ง:',
  BillingWeight: 'น้ำหนักคิดค่าบริการ:',
  CalculationMethod: 'วิธีการคำนวณ:',
  TheTypeCannotBeEmpty: 'ประเภทการมอบหมายไม่สามารถเว้นว่างได้',
  TransportTypeCannotBeEmpty: 'ประเภทการขนส่งไม่สามารถเว้นว่างได้',
  FullJourneyCannotBeEmpty: 'เต็มเส้นทาง/ครึ่งเส้นทางไม่สามารถเว้นว่างได้',
  ShippingRouteCannotBeEmpty: 'เส้นทางบินไม่สามารถเว้นว่างได้',
  DepartureBeLaterThanDate: 'วันที่ส่งออกไม่สามารถช้ากว่าวันที่ถึงได้',
  DepartureStationCannotBeEmpty: 'สถานีเริ่มต้นไม่สามารถเว้นว่างได้',
  TransitStationCannotBeEmpty: 'สถานีเปลี่ยนผ่านไม่สามารถเว้นว่างได้',
  TransitStationCannotBeEmpty2: 'สถานีผ่านแดนไม่สามารถเว้นว่างได้',
  DestinationStationCannotBeEmpty: 'สถานีปลายทางไม่สามารถเว้นว่างได้',
  PaymentMethodCannotBeEmpty: 'วิธีการชำระเงินไม่สามารถเว้นว่างได้',
  SalesCannotBeEmpty: 'ฝ่ายขายไม่สามารถเว้นว่างได้',
  OperationCannotBeEmpty: 'การดำเนินการไม่สามารถเว้นว่างได้',
  AlreadyOtherBoxTypesTime: 'ได้เลือก [รถเปิด/รถมีหลังคา/รถแบน] แล้ว ไม่สามารถเลือกประเภทตู้สินค้านอกเหนือจากนี้ได้!',
  EstimatedTimeCannotBeEmpty: 'เวลาที่คาดว่าจะเข้าคลัง/สินค้าพร้อมไม่สามารถเว้นว่างได้!',
  DestinationCannotBeEmpty: 'ปลายทางไม่สามารถเว้นว่างได้!',
  DestinationCountryCannotBeEmpty: 'ประเทศปลายทางไม่สามารถเว้นว่างได้!',
  ZipCodeCannotBeEmpty: 'รหัสไปรษณีย์ไม่สามารถเว้นว่างได้!',
  CannotBeEmpty: 'ไม่สามารถเว้นว่างได้!',
  PleaseTheEntrustingUnitFirst: 'กรุณาเลือกหน่วยงานที่มอบหมายก่อน',
  EstimatedStoragegoodReadyTime: 'เวลาที่คาดว่าจะเข้าคลัง/สินค้าพร้อม',
  NoTicketChecked: 'ไม่ได้เลือกใบเสร็จ',
  CustomersOwnContainer: 'ตู้สินค้าของลูกค้า',
  CompanyOwnedContainer: 'ตู้สินค้าของบริษัท',
  RentalContainer: 'ตู้สินค้าเช่าภายนอก',
  ContainerUsageImportTemplateRailwayXls: 'เทมเพลตการนำเข้าการใช้งานตู้สินค้า(ทางรถไฟ).xls',
  CurrentBeenSubmittedCannotOperate: 'ธุรกิจปัจจุบันได้ส่งแล้ว ไม่สามารถดำเนินการได้!',
  AreWantToPerformOperation: 'ยืนยันที่จะดำเนินการนี้หรือไม่?',
  CostNotConfiguredPleaseCheck: 'ยังไม่ได้กำหนดประเภทค่าใช้จ่าย กรุณาตรวจสอบ!',
  CostAuditedOrInvoicedCheck: 'ค่าใช้จ่ายได้รับการตรวจสอบหรือออกใบแจ้งหนี้แล้ว กรุณาตรวจสอบ!',
  CleaningCompletedSuccessfulCleaningNumber: 'ทำความสะอาดเสร็จสิ้น! จำนวนที่ทำความสะอาดสำเร็จ:',
  PleaseBoxesYouWantProcess: 'กรุณาเลือกตู้สินค้าที่ต้องการดำเนินการ!',
  ContainsContainerDataPleaseCheck: 'มีข้อมูลตู้สินค้าที่ยังไม่ได้ปรับ กรุณาตรวจสอบ!',
  PleaseSelectAContainer: 'กรุณาเลือกตู้สินค้าหนึ่งตู้',
  FirstLeglastLeg: 'เฟิสต์ไมล์/ลาสต์ไมล์',
  TransportationMethod: 'วิธีการขนส่ง',
  ContactPerson: 'ผู้ติดต่อ',
  DetailedAddress: 'ที่อยู่ละเอียด',
  FirstLeglastLegInformation: 'ข้อมูลเฟิสต์ไมล์/ลาสต์ไมล์',
  CustomerDoordestinationPortDoor: 'จุดรับส่งของลูกค้า/จุดรับส่งที่ท่าเรือปลายทาง',
  CustomerContactPerson: 'ผู้ติดต่อลูกค้า',
  FirstLegCannotBeEmpty: 'เฟิสต์ไมล์/ลาสต์ไมล์ไม่สามารถเว้นว่างได้',
  PleaseEnterTransportationCompanyInformation: 'กรุณากรอกข้อมูลบริษัทขนส่ง',
  PleaseSelectDesignatedData: 'กรุณาเลือกข้อมูลที่กำหนด',
  PleaseSelectTradeInformation: 'กรุณาเลือกข้อมูลการค้า',
  RailwayOperationGoodsDetails: 'รายละเอียดสินค้าดำเนินการทางรถไฟ',
  SellingContainer: 'ขายตู้คอนเทนเนอร์',
  TotalPurchaseContainer: 'จำนวนตู้คอนเทนเนอร์ที่ซื้อทั้งหมด',
  TotalCostAmount: 'ยอดรวมต้นทุน',
  TotalSoldContainer: 'จำนวนตู้คอนเทนเนอร์ที่ขายทั้งหมด',
  TotalSellingAmount: 'ยอดรวมการขาย',
  ModificationSuccessful: 'แก้ไขสำเร็จ',
  BuyingContainer: 'ซื้อตู้คอนเทนเนอร์',
  Yes: 'ใช่',
  No: 'ไม่',
  PleaseTheContainerToEdit: 'กรุณาเลือกตู้คอนเทนเนอร์ที่ต้องการแก้ไข!',
  EditOrderInformation: 'แก้ไขข้อมูลคำสั่งซื้อ',
  PleaseTheContainerToDelete: 'กรุณาเลือกตู้คอนเทนเนอร์ที่ต้องการลบ!',
  AreWantToDeleteInformation: 'ยืนยันการลบข้อมูลตู้คอนเทนเนอร์นี้?',
  PromptInformation: 'ข้อความแจ้งเตือน',
  DeletingOrderContainsOccupiedContainers: 'คำสั่งซื้อที่ลบประกอบด้วยตู้คอนเทนเนอร์ที่ถูกใช้งานแล้ว!',
  CurrentlySelected: '(ที่เลือกอยู่ในปัจจุบัน)',
  CurrentPage: '(หน้าปัจจุบัน)',
  CurrentlyAvailable: 'พร้อมใช้งานปัจจุบัน',
  CurrentlyOccupied: 'ถูกใช้งานปัจจุบัน',
  Sold: 'ขายแล้ว',
  ContainerInquiry: 'ค้นหาตู้คอนเทนเนอร์',
  BoxReturnedCannotContinueOperate: 'ตู้คอนเทนเนอร์หมายเลข: {0} ได้คืนแล้ว ไม่สามารถดำเนินการต่อได้!'
}

